// AUTO-GENERATED - DO NOT EDIT MANUALLY

import { OfferEngineType } from './enums.gen';
import { hydrateSessionEngineRecurrent, type SessionEngineRecurrent, type SessionEngineRecurrentApiResponse } from './sessionEngineRecurrent.gen';
import { hydrateSessionEngineEvent, type SessionEngineEvent, type SessionEngineEventApiResponse } from './sessionEngineEvent.gen';

export type SessionEngineApiResponse = SessionEngineRecurrentApiResponse | SessionEngineEventApiResponse;
export type SessionEngine = SessionEngineRecurrent | SessionEngineEvent;

export function hydrateSessionEngine(data: SessionEngineApiResponse): SessionEngine {
	return data.type === OfferEngineType.Recurrent
		? hydrateSessionEngineRecurrent(data as SessionEngineRecurrentApiResponse)
		: hydrateSessionEngineEvent(data as SessionEngineEventApiResponse);
}